var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"layout-header"},[_c('Menu',_vm._b({},'Menu',{mode:'horizontal',theme:'light'},false),[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }